/** Shoot time zone picker: the common zones first, then every IANA zone the browser knows (Sydney, Anchorage, Mexico City…). */
import { useMemo, type SelectHTMLAttributes } from 'react';
import { Select } from '../components/ui';
import { timeZoneOptions } from '../lib/time';

const label = (z: string) => z.replace(/_/g, ' ');

export function TimeZoneSelect({ value, onChange, ...rest }: Omit<SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange'> & { value: string; onChange(z: string): void }) {
  const { common, other } = useMemo(() => timeZoneOptions(value), [value]);
  return (
    <Select {...rest} value={value} onChange={(e) => onChange(e.target.value)}>
      <optgroup label="Common">
        {common.map((z) => (
          <option key={z} value={z}>
            {label(z)}
          </option>
        ))}
      </optgroup>
      {other.length ? (
        <optgroup label="All time zones">
          {other.map((z) => (
            <option key={z} value={z}>
              {label(z)}
            </option>
          ))}
        </optgroup>
      ) : null}
    </Select>
  );
}
